// extracted by mini-css-extract-plugin
export default {"description":"CCfSBE7DD80K_Fc2feOL","list":"mw9vCrZ5NCjRceYMyQ7M","listItem":"hPMbR1F6ZzqF70poPa8Q","iocContent":"sznAaGqW5XowSeB4ste4"};